<div class="dialog-container-files scrollbar-custom-scroll-style">
  <table class="file-table">
    <thead>
      <tr class="file-top-header-row">
        <th class="colummn-header wgt-25p">Files</th>
        <th class="colummn-header">Description</th>
        <th class="wgt-5p"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of fileSectionMapping; let i = index">
        <td class="wgt-25p file-name">{{ file.file_name }}</td>
        <td>
          <input
            type="text"
            [(ngModel)]="file.description"
            placeholder="Enter Description"
            class="description-input"
          />
        </td>
        <td class="wgt-5p">
          <img
            src="../../../../assets/icons/svg/garbage.svg"
            alt="Delete"
            class="bin-icon"
            (click)="removeFile(i)"
            (keydown)="removeFile(i)"
          />
        </td>
      </tr>
      <tr
        *ngIf="fileSectionMapping.length * 60 < 400"
        class="filler-row"
        [ngClass]="getFillerRowClass()"
      >
        <td class="wgt-25p"></td>
        <td></td>
        <td class="wgt-5p"></td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="file-bottom-row">
        <td class="wgt-25p"></td>
        <td>
          <div class="dialog-actions">
            <button class="btn cancel-btn" (click)="onCancel()">Cancel</button>
            <button class="btn upload-btn" (click)="uploadOtherDocuments()">
              Upload
            </button>
          </div>
        </td>
        <td class="wgt-5p"></td>
      </tr>
    </tfoot>
  </table>
</div>
